module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/file-alt.svg?1defef0d9dcfd02f514dd5d313cb40bd";